import "@fontsource/roboto";
import { deepPurple, teal, grey, amber } from "@mui/material/colors";
import { CONTRAST_THRESHOLD, THEME_NAMES } from "../../constants/global";

export const themesCollection = {
  [THEME_NAMES.PurpleDash]: {
    light: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.2,

        primary: {
          main: deepPurple[500],
        },
        secondary: {
          main: teal[400],
        },
        background: {
          default: grey[50],
          paper: deepPurple[50],
        },

        util: {
          highlight: amber[300],
          llmChatBackground: deepPurple[100],
        },
      },
    },
    dark: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.15,

        primary: {
          main: deepPurple[300],
        },
        secondary: {
          main: teal[700],
        },
        background: {
          paper: grey[900],
        },

        util: {
          highlight: amber[900],
          llmChatBackground: grey[800],
        },
      },
    },
  },
  [THEME_NAMES.InfuseClassic]: {
    light: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.2,

        primary: {
          main: "#1c3c70",
        },
        secondary: {
          main: "#fe6000",
        },
        background: {
          default: grey[50],
          paper: "#e3eff6",
        },

        util: {
          highlight: amber[300],
          llmChatBackground: "#bbd8eb",
        },
      },
    },
    dark: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.15,

        primary: {
          main: "#6ea7d0",
        },
        secondary: {
          main: "#ffcd47",
        },
        background: {
          paper: grey[900],
        },

        util: {
          highlight: amber[900],
          llmChatBackground: grey[800],
        },
      },
    },
  },
  [THEME_NAMES.GoldenRush]: {
    light: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.2,

        primary: {
          main: "#ec9d00",
        },
        secondary: {
          main: "#0433ef",
        },
        background: {
          default: grey[50],
          paper: "#fdfce5",
        },

        util: {
          highlight: amber[300],
          llmChatBackground: "#f9e8ae",
        },
      },
    },
    dark: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.15,

        primary: {
          main: "#eece10",
        },
        secondary: {
          main: "#8673f9",
        },
        background: {
          paper: grey[900],
        },

        util: {
          highlight: amber[900],
          llmChatBackground: grey[800],
        },
      },
    },
  },
  [THEME_NAMES.Retro]: {
    light: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.2,

        primary: {
          main: "#D41A21",
        },
        secondary: {
          main: "#1E93AB",
        },
        background: {
          default: "#F3F2EC",
          paper: "#ffeaed",
        },

        util: {
          highlight: amber[300],
          llmChatBackground: "#ffcacf",
        },
      },
    },
    dark: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.15,

        primary: {
          main: "#E76B6A",
        },
        secondary: {
          main: "#36c2e0",
        },
        background: {
          paper: grey[900],
        },

        util: {
          highlight: amber[900],
          llmChatBackground: grey[800],
        },
      },
    },
  },
  [THEME_NAMES.Halloween]: {
    light: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.2,

        primary: {
          main: "#872341",
        },
        secondary: {
          main: "#F05941",
        },
        background: {
          default: grey[50],
          paper: "#fcecf1",
        },

        util: {
          highlight: amber[300],
          llmChatBackground: "#f8cfd9",
        },
      },
    },
    dark: {
      palette: {
        contrastThreshold: CONTRAST_THRESHOLD,
        tonalOffset: 0.15,

        primary: {
          main: "#BE3144",
        },
        secondary: {
          main: "#F05941",
        },
        background: {
          default: "#22092C",
          paper: "#321741",
        },

        util: {
          highlight: amber[900],
          llmChatBackground: grey[800],
        },
      },
    },
  },
};

export const themesList = [
  {
    name: THEME_NAMES.PurpleDash,
    description: "Purple dash and neon flash",
    lightThumbnailPath: "/assets/svgs/purple_dash_theme_icon_light.svg",
    darkThumbnailPath: "/assets/svgs/purple_dash_theme_icon_dark.svg",
  },
  {
    name: THEME_NAMES.InfuseClassic,
    description: "Ha-ha-ha, classic",
    lightThumbnailPath: "/assets/svgs/infuse_classic_theme_icon_light.svg",
    darkThumbnailPath: "/assets/svgs/infuse_classic_theme_icon_dark.svg",
  },
  {
    name: THEME_NAMES.GoldenRush,
    description: "Silver is no longer fashionable",
    lightThumbnailPath: "/assets/svgs/golden_rush_theme_icon_light.svg",
    darkThumbnailPath: "/assets/svgs/golden_rush_theme_icon_dark.svg",
  },
  {
    name: THEME_NAMES.Retro,
    description: "For true fans of the 80s",
    lightThumbnailPath: "/assets/svgs/retro_theme_icon_light.svg",
    darkThumbnailPath: "/assets/svgs/retro_theme_icon_dark.svg",
  },
  {
    name: THEME_NAMES.Halloween,
    description: "Prettier in dark mode on October 31s",
    lightThumbnailPath: "/assets/svgs/halloween_theme_icon_light.svg",
    darkThumbnailPath: "/assets/svgs/halloween_theme_icon_dark.svg",
  },
];

export const defaultThemeName = THEME_NAMES.PurpleDash;
